var map = {
	"./2023/autumn/poster/battle_report_jjc.png": "ae09",
	"./2023/summer/poster/battle_report_jjc.png": "c06d",
	"./2024/autumn/poster/battle_report_jjc.png": "9f79",
	"./2024/summer/poster/battle_report_jjc.png": "7f92",
	"./2024/winter/poster/battle_report_jjc.png": "40f7",
	"./2025/spring/poster/battle_report_jjc.png": "4784",
	"./2025/summer/poster/battle_report_jjc.png": "7b1d",
	"./2025/winter/poster/battle_report_jjc.png": "d365"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a2c9";